import React, { useState, useEffect } from "react";
import * as S from "./index-styled";
import AuthForm from "./Auth";
import RegistrationForm from "./Registration";
import { useTranslation } from "react-i18next";
import ScrollLock from "_c/ScrollLock";
import { FullScreenSpin as Spin } from "_c/preloader";
import { useHeader } from "./hooks/useHeader";

const AuthModal = (props) => {
  const { mode, affiliateData } = props;
  const { t, ready } = useTranslation(["login", "errors", "common"], {
    useSuspense: false,
  });
  const [restorePasswordMode, setRestorePasswordMode] = useState(false);
  useEffect(() => {
    if (props.affiliateData) {
      props.changeMode("register");
    }
  }, []);
  const header = useHeader({
    t,
    mode: restorePasswordMode ? "restorePassword" : mode,
    enabled: ready,
  });
  if (!ready) return <Spin />;
  return (
    <>
      <S.GlobalStyle />
      <ScrollLock />
      <S.Wrap>
        <S.TabsList>
          <S.TabItem
            onClick={() => props.changeMode("register")}
            isSelected={mode === "register"}
            aria-selected={mode === "register"}
          >
            {t("login:reg_tab")}
          </S.TabItem>
          <S.TabItem
            onClick={() => props.changeMode("auth")}
            isSelected={mode === "auth"}
            aria-selected={mode === "auth"}
          >
            {t("login:auth_tab")}
          </S.TabItem>
        </S.TabsList>
        {mode === "register" && (
          <>
            <S.Header>{header}</S.Header>
            <RegistrationForm t={t} />
          </>
        )}
        {mode === "auth" && (
          <>
            <S.Header>{header}</S.Header>
            <AuthForm
              t={t}
              showRestore={restorePasswordMode}
              changeRestorePasswordMode={setRestorePasswordMode}
            />
          </>
        )}
        <S.Body>
          {mode === "register" && affiliateData && (
            <S.Flash>
              {t("login:affiliate_tip.1")}{" "}
              {affiliateData.affiliate_type === "master"
                ? t("login:affiliate_tip.master")
                : t("login:affiliate_tip.client")}
            </S.Flash>
          )}
        </S.Body>
      </S.Wrap>
      <S.MobileCloseButton onClick={() => props.close()}>
        {t("common:close")}
      </S.MobileCloseButton>
    </>
  );
};

export default AuthModal;
